import axios from "@/utils/axios";
import { useQuery } from "@tanstack/react-query";

interface FileResponse {
  id: string;
  uuid: string;
  file_name: string;
  mime_type: string;
  size: number;
  url: string;
  preview_url?: string;
  created_at: string;
  updated_at: string;
  // Agrega más campos según la respuesta real
}

/**
 * Hook para obtener un archivo por su ID
 *
 * @param fileId - ID del archivo
 * @returns Query result con los datos del archivo
 */
export const useGetFile = (fileId: string) => {
  return useQuery({
    queryKey: ["file", fileId],
    queryFn: async (): Promise<FileResponse> => {
      const response = await axios.get(
        `/admin/v1/generated-document/${fileId}/download`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      return response.data;
    },
    enabled: !!fileId,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
};
